import {
  ADD_PREVIEW,
  ADD_ID,
  DELETE_PREVIEW
} from './mutations-types'
import functions from '../../../helpers/functions'
import axios from 'axios'
import firebase from '../../../firebase/main'

export default {
  parseSpreadsheet ({ dispatch, commit }, id) {
    const url = 'http://localhost:1458/preview/'
    return axios.get(url, {
      params: {
        id,
        title: 'Messaging plan'
      }
    })
      .then(res => {
        if (res.data.found) {
          res.data.messages.forEach(message => {
            dispatch('getPreview', Object.assign(message, {callToAction: 'LEARN_MORE'}))
          })
        } else {
          const notification = {
            type: 'warning',
            message: ['Messages not found']
          }
          dispatch('showNotification', notification)
        }
      })
  },
  getPreview ({ commit }, params) {
    return new Promise(resolve => {
      resolve(functions.getMessagePreview(params))
    })
      .then(res => {
        const arr = res.split(' ')
        const preview = `${arr[0]} ${arr[1]} scrolling="no" width=auto height=auto></iframe>`
        commit(ADD_PREVIEW, preview)
      })
  },
  storePreviews ({ state, commit }) {
    state.previews.forEach((preview, index) => {
      return new Promise(resolve => {
        resolve(firebase.Previews.addPreview(preview))
      })
        .then(id => {
          commit(DELETE_PREVIEW, preview)
          commit(ADD_ID, id)
        })
    })
  }
}
